document.getElementById('find_support_ipad').addEventListener('click', function(event) {
  event.preventDefault(); 
  document.querySelector('.popup-modal__overlay').style.display = 'flex';
  function closeModal() {
    document.querySelector('.popup-modal__overlay').style.display = 'none';
  }
  document.querySelector('.popup-modal__close').addEventListener('click', function() {
    closeModal();
  });
  document.querySelector('.popup-modal__overlay').addEventListener('click', function(event) {
   const modalContent = document.querySelector('.popup-modal__outer');
    if (!modalContent.contains(event.target)) {
      closeModal();
    }
  });
});
